import { render, staticRenderFns } from "./gmclound.vue?vue&type=template&id=5c81a940&scoped=true"
import script from "./gmclound.vue?vue&type=script&lang=js"
export * from "./gmclound.vue?vue&type=script&lang=js"
import style0 from "./gmclound.vue?vue&type=style&index=0&id=5c81a940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c81a940",
  null
  
)

export default component.exports